import React from 'react';
import PropTypes from 'prop-types';
import './MarketplaceBadge.css';

/**
 * MarketplaceBadge - Badge of Honor for strategies published to marketplace
 *
 * Shows a prominent badge indicating the strategy is publicly available
 * in the marketplace for others to discover and clone.
 *
 * @param {string} size - 'small' (for lists), 'large' (for detail pages), or 'hero' (for modals)
 * @param {string} marketplaceListingId - Optional ID to link to marketplace listing
 * @param {string} className - Additional CSS classes
 */
export default function MarketplaceBadge({
  size = 'small',
  marketplaceListingId = null,
  className = ''
}) {
  const tooltip = "🌟 Listed on Marketplace — Your strategy is publicly available for others to discover, clone, and learn from. A true badge of honor!";

  const badge = (
    <span
      className={`marketplace-badge marketplace-badge--${size} ${className}`}
      title={tooltip}
    >
      {/* Globe icon - represents global/public availability */}
      <svg
        className="marketplace-badge__icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
      <span className="marketplace-badge__text">Listed</span>
    </span>
  );

  // If we have a listing ID, wrap in a link to the marketplace page
  if (marketplaceListingId) {
    return (
      <a
        href={`/marketplace/strategy/${marketplaceListingId}`}
        className="marketplace-badge__link"
        onClick={(e) => e.stopPropagation()}
      >
        {badge}
      </a>
    );
  }

  return badge;
}

MarketplaceBadge.propTypes = {
  size: PropTypes.oneOf(['small', 'large', 'hero']),
  marketplaceListingId: PropTypes.string,
  className: PropTypes.string,
};
